import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const EmailConfig = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testingSending, setTestingSending] = useState(false);
  const [config, setConfig] = useState({
    smtp_host: '',
    smtp_port: '',
    smtp_user: '',
    smtp_pass: '',
    smtp_secure: false,
    from_name: ''
  });
  const [presets, setPresets] = useState([
    { name: 'Gmail', host: 'smtp.gmail.com', port: '587', secure: false },
    { name: 'Outlook/Hotmail', host: 'smtp.office365.com', port: '587', secure: false },
    { name: 'SendGrid', host: 'smtp.sendgrid.net', port: '587', secure: false },
    { name: 'Amazon SES', host: 'email-smtp.us-east-1.amazonaws.com', port: '587', secure: false },
    { name: 'Mailgun', host: 'smtp.mailgun.org', port: '587', secure: false }
  ]);
  const [testEmail, setTestEmail] = useState('');

  useEffect(() => {
    const fetchEmailConfig = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await axios.get('/api/admin/email-config', {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data) {
          setConfig(response.data);
        }
      } catch (error) {
        console.error('Erro ao buscar configurações de email:', error);
        if (error.response?.status !== 404) {
          toast.error('Erro ao carregar configurações de email. Tente novamente.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEmailConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePresetSelect = (preset) => {
    setConfig(prev => ({
      ...prev,
      smtp_host: preset.host,
      smtp_port: preset.port,
      smtp_secure: preset.secure
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Você precisa estar logado para salvar configurações.');
        return;
      }

      await axios.post('/api/admin/email-config', config, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Configurações de email salvas com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar configurações de email:', error);
      toast.error('Erro ao salvar configurações. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleTestEmail = async (e) => {
    e.preventDefault();
    
    if (!testEmail) {
      toast.error('Por favor, informe um email para teste.');
      return;
    }
    
    setTestingSending(true);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Você precisa estar logado para enviar email de teste.');
        return;
      }

      await axios.post('/api/admin/test-email', 
        { email: testEmail, config },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success('Email de teste enviado com sucesso!');
    } catch (error) {
      console.error('Erro ao enviar email de teste:', error);
      toast.error(`Erro ao enviar email: ${error.response?.data?.message || 'Tente novamente.'}`);
    } finally {
      setTestingSending(false);
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        {/* Header */}
        <header className="navbar navbar-expand-md navbar-light d-print-none">
          <div className="container-xl">
            <h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
              <Link to="/">
                <img src="https://preview.tabler.io/static/logo.svg" width="110" height="32" alt="Tabler" className="navbar-brand-image" />
              </Link>
            </h1>
            <div className="navbar-nav flex-row order-md-last">
              <div className="nav-item dropdown">
                <a href="#" className="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown">
                  <div className="d-none d-xl-block ps-2">
                    <div>Administrador</div>
                    <div className="mt-1 small text-muted">Configurações de Email</div>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <a href="#" className="dropdown-item" onClick={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    window.location.href = '/login';
                  }}>Sair</a>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Navbar */}
        <div className="navbar-expand-md">
          <div className="collapse navbar-collapse" id="navbar-menu">
            <div className="navbar navbar-light">
              <div className="container-xl">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                          <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                          <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
                        </svg>
                      </span>
                      <span className="nav-link-title">Dashboard</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/setup" className="nav-link">
                      <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                          <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
                        </svg>
                      </span>
                      <span className="nav-link-title">Configurações</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/reports" className="nav-link">
                      <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                          <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                          <path d="M9 17h6"></path>
                          <path d="M9 13h6"></path>
                        </svg>
                      </span>
                      <span className="nav-link-title">Relatórios</span>
                    </Link>
                  </li>
                  <li className="nav-item active">
                    <Link to="/admin/email-config" className="nav-link">
                      <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"></path>
                          <path d="M3 7l9 6l9 -6"></path>
                        </svg>
                      </span>
                      <span className="nav-link-title">Config. Email</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Page content */}
        <div className="page-body">
          <div className="container-xl">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Configurações do Servidor de Email</h3>
              </div>
              <div className="card-body">
                {loading ? (
                  <div className="text-center p-4">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-3">Carregando configurações...</p>
                  </div>
                ) : (
                  <>
                    <div className="alert alert-info mb-4">
                      <div className="d-flex">
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M12 9h.01"></path>
                            <path d="M11 12h1v4h1"></path>
                            <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"></path>
                          </svg>
                        </div>
                        <div>
                          <h4 className="alert-title">Informações importantes</h4>
                          <div className="text-muted">
                            <p>Estas configurações são usadas para enviar emails de verificação de conta e recuperação de senha.</p>
                            <p>Se estiver usando Gmail, você precisará ativar a verificação em duas etapas e criar uma senha de aplicativo.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="form-label">Selecione um provedor pré-configurado:</label>
                      <div className="d-flex flex-wrap gap-2">
                        {presets.map((preset, index) => (
                          <button 
                            key={index} 
                            type="button" 
                            className="btn btn-outline-primary"
                            onClick={() => handlePresetSelect(preset)}
                          >
                            {preset.name}
                          </button>
                        ))}
                      </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Servidor SMTP (Host)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="smtp_host"
                            value={config.smtp_host}
                            onChange={handleChange}
                            placeholder="Ex: smtp.gmail.com"
                            required
                          />
                          <small className="form-hint">Endereço do servidor SMTP.</small>
                        </div>
                        
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Porta SMTP</label>
                          <input
                            type="text"
                            className="form-control"
                            name="smtp_port"
                            value={config.smtp_port}
                            onChange={handleChange}
                            placeholder="Ex: 587"
                            required
                          />
                          <small className="form-hint">Porta do servidor SMTP (geralmente 587 ou 465).</small>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Email de Envio</label>
                          <input
                            type="email"
                            className="form-control"
                            name="smtp_user"
                            value={config.smtp_user}
                            onChange={handleChange}
                            placeholder="seu-email@exemplo.com"
                            required
                          />
                          <small className="form-hint">Email que será usado para enviar as mensagens.</small>
                        </div>
                        
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Senha</label>
                          <input
                            type="password"
                            className="form-control"
                            name="smtp_pass"
                            value={config.smtp_pass}
                            onChange={handleChange}
                            placeholder="Senha ou chave de aplicativo"
                            required
                          />
                          <small className="form-hint">Senha do email ou chave de aplicativo (recomendado).</small>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Nome de Exibição</label>
                          <input
                            type="text"
                            className="form-control"
                            name="from_name"
                            value={config.from_name}
                            onChange={handleChange}
                            placeholder="Plataforma de Investimentos"
                          />
                          <small className="form-hint">Nome que aparecerá como remetente dos emails.</small>
                        </div>
                        
                        <div className="col-md-6 mb-3">
                          <div className="form-check form-switch mt-4">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="smtp_secure"
                              checked={config.smtp_secure}
                              onChange={handleChange}
                            />
                            <label className="form-check-label">Usar conexão segura (SSL/TLS)</label>
                          </div>
                          <small className="form-hint">Ative para porta 465, desative para porta 587.</small>
                        </div>
                      </div>
                      
                      <div className="form-footer d-flex justify-content-between">
                        <button type="submit" className="btn btn-primary" disabled={saving}>
                          {saving ? 'Salvando...' : 'Salvar Configurações'}
                        </button>
                      </div>
                    </form>

                    <hr className="my-4" />

                    <h4>Testar Configuração</h4>
                    <p className="text-muted">Envie um email de teste para verificar se as configurações estão corretas.</p>
                    
                    <form onSubmit={handleTestEmail} className="row g-3">
                      <div className="col-md-8">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email para teste"
                          value={testEmail}
                          onChange={(e) => setTestEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <button type="submit" className="btn btn-outline-primary w-100" disabled={testingSending}>
                          {testingSending ? 'Enviando...' : 'Enviar Email de Teste'}
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer footer-transparent d-print-none">
          <div className="container-xl">
            <div className="row text-center align-items-center flex-row-reverse">
              <div className="col-12 col-lg-auto mt-3 mt-lg-0">
                <ul className="list-inline list-inline-dots mb-0">
                  <li className="list-inline-item">
                    Copyright © 2023 Plataforma de Investimentos
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default EmailConfig; 